import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { ComparisonDirective } from './comparison.directive';
export class GreaterThanDirective extends ComparisonDirective {
public ngGreaterThan: any;
constructor() {
    super('ngGreaterThan');
  }
/**
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl): boolean {
    return control.value > this.ngGreaterThan;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngGreaterThan]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: GreaterThanDirective,
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngGreaterThan': [{ type: Input },],
};
}

function GreaterThanDirective_tsickle_Closure_declarations() {
/** @type {?} */
GreaterThanDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GreaterThanDirective.ctorParameters;
/** @type {?} */
GreaterThanDirective.propDecorators;
/** @type {?} */
GreaterThanDirective.prototype.ngGreaterThan;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
